import React from "react";
import Image from "next/image";

import PetTagButton from "../button/PetTagButton";
import { ScrollArea } from "../ScrollArea";
import { SHOWCASE_IMAGES_URL } from "@/utils/constants/pet-tag";

function PetShowcase({ onClick }) {
  return (
    <section className="showcase-background lg:px-[112px] py-[3.25rem] lg:py-0">
      <div className="h-auto lg:h-[944px] w-full flex flex-col lg:flex-row  lg:justify-between items-center max-w-[1328px] mx-auto">
        <div className="flex flex-col items-center lg:items-start">
          <div className="w-[187px] h-[157px] lg:w-[234px] lg:h-[72px] relative">
            <Image src="/assets/pet-tag/smart.svg" fill alt="smart" />
          </div>

          <p className="text-[1.625rem] lg:text-[2rem] text-white mt-[0.6rem] lg:mt-3 opacity-80">
            Pet Tag already have
          </p>

          <div className="w-[314px] h-[106px] lg:w-[393] lg:h-[132] relative my-4 lg:my-5">
            <Image src="/assets/pet-tag/120.svg" alt="success-num" fill />
          </div>

          <p className="text-[2.375rem] lg:text-5xl font-bold text-white w-[17.688rem] leading-[3rem] text-center lg:text-left">
            Successful Pet Reunions
          </p>

          <p className="text-white opacity-80 text-2xl leading-[2.4rem] w-[25.125rem] mt-5 mb-10 hidden lg:block">
            Proudly bringing pets and their families back together, one tag at a
            time.
          </p>
          <div className="mt-[2rem] lg:mt-0">
            <PetTagButton onClick={onClick} />
          </div>
        </div>

        <div className="h-[750px] lg:h-full mt-[2.5rem] lg:mt-0 ">
          <ScrollArea className="h-full">
            <div className="grid grid-cols-2 gap-5 lg:gap-8 min-[380px]:p-5">
              {SHOWCASE_IMAGES_URL.map((url, index) => (
                <div
                  className="w-[161px] min-[380px]:w-[181px] h-[104px] lg:w-[290px] lg:h-[168px] relative rounded-[1.125rem] lg:rounded-[1.5rem]"
                  key={index}
                >
                  <Image
                    src={url}
                    fill
                    alt="pet"
                    sizes="640px"
                    quality={40}
                    className="rounded-[1.125rem] lg:rounded-[1.5rem] object-cover"
                  />
                </div>
              ))}
            </div>
          </ScrollArea>
        </div>
      </div>
    </section>
  );
}

export default PetShowcase;
